
import { getSearchParamsFromRoute } from "@utils";

const WORDLE_TILE_COUNT = 5;

export default {
	computed: {
		isInlineFinderResultsPage() {
			return this.$store.getters["navigation/isInlineFinderResultsPage"];
		},
		/**
		 * These results pages show the searched word in an inactive (greyed out)
		 * state, the way they did before the blue branding. Tapping the bar
		 * swaps in the Finder itself, which is the active state.
		 *
		 * @see WFW-6761
		 */
		showsSearchedWord() {
			return Boolean(
				this.$isBlueBranding &&
					this.isInlineFinderResultsPage &&
					this.$route.params?.tiles
			);
		},
		isWordleStyle() {
			return (
				this.$store.getters["navigation/isWordleResultsPage"] ||
				this.$store.getters["navigation/isQuordleResultsPage"]
			);
		},
		/**
		 * The five correct-position tiles, with unknown positions as empty
		 * strings so the template can style them as blanks.
		 * @returns {String[]}
		 */
		correctTiles() {
			const params = getSearchParamsFromRoute(this.$route);
			const correct = params.clean?.wordle?.correct || "";

			return Array.from({ length: WORDLE_TILE_COUNT }, (_, index) => {
				const letter = correct[index];
				return letter && letter !== "_" ? letter : "";
			});
		},
		/**
		 * The tiles are the only indication of the current search, so the
		 * button spells them out rather than leaving screen readers with five
		 * unlabelled boxes.
		 */
		wordleAriaLabel() {
			const entered = this.correctTiles
				.map((letter, index) =>
					letter
						? `${letter.toUpperCase()} in position ${index + 1}`
						: null
				)
				.filter(Boolean)
				.join(", ");

			return entered
				? `Edit your search. Letters in the correct position: ${entered}`
				: "Edit your search";
		},
		placeholder() {
			if (this.showsSearchedWord) {
				return this.$route.params.tiles;
			}

			if (this.$isBlueBranding) {
				return "EDIT YOUR SEARCH";
			}
			return (
				((this.$store.getters["navigation/isUnscramblerResultsPage"] ||
					this.isInlineFinderResultsPage) &&
					this.$route.params?.tiles) ||
				"ENTER LETTERS"
			);
		},
		tilesFontsize() {
			const smallerLettersThreshold = 15;
			const queryLength = this.placeholder.length;
			const fontSize = queryLength >= smallerLettersThreshold ? 22 : 25;
			if (queryLength >= smallerLettersThreshold) {
				return `${
					fontSize - (queryLength - smallerLettersThreshold)
				}px`;
			}
			return null;
		},
	},
	methods: {
		onClick() {
			this.$emit("click");
		},
	},
};
